import { Outlet, useLocation } from 'react-router-dom'
import { useItemLabel } from '@/hooks/useIndustry'
import { Sidebar } from './Sidebar'
import { TITLES } from './titles'
import { Topbar } from './Topbar'
import { ImpersonationBanner } from './ImpersonationBanner'
import { SubscriptionBanner } from './SubscriptionBanner'


export function AppShell() {
  const { pathname } = useLocation()
  const itemLabel = useItemLabel()

  // The catalogue's title follows the shop's own word, so the topbar agrees
  // with the nav item that got you here. Everything else is a fixed noun.
  const title =
    (pathname.startsWith('/products') ? itemLabel.plural : undefined) ??
    TITLES[pathname] ??
    TITLES[`/${pathname.split('/')[1]}`] ??
    'Voltra POS'

  return (
    // h-dvh + overflow-hidden, NOT min-h-dvh: the shell owns exactly one
    // viewport and only <main> scrolls. With min-h-dvh the document itself
    // grows, and the sidebar — however tall — scrolls away with it, taking the
    // nav and the outlet switcher off screen halfway down a long product list.
    <div className="flex h-dvh overflow-hidden">
      <Sidebar />

      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        {/* Fixed chrome. shrink-0 so a long page cannot squeeze the topbar. */}
        <div className="shrink-0">
          <ImpersonationBanner />
          <Topbar title={title} />
          <SubscriptionBanner />
        </div>

        {/* min-h-0 is what actually lets this scroll — a flex child's default
            min-height:auto refuses to shrink below its content. */}
        <main className="scroll-slim min-h-0 flex-1 overflow-y-auto px-6 py-6">
          <div className="mx-auto max-w-[1440px]">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
